import { Component } from '@angular/core';

@Component({
  selector: 'app-loading3',
  templateUrl: './loading3.component.html',
  styleUrls: ['./loading3.component.scss']
})
export class Loading3Component {

}
